import { SVGProps } from 'react';
const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_917_415)">
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="url(#paint0_linear_917_415)"
      />
      <path
        d="M29.0582 25.4255L29.7645 20.7298H25.6047V17.4597C25.6047 16.1179 26.0755 15.1118 27.9592 15.1118H30V10.8354C28.9011 10.6677 27.6453 10.5 26.5466 10.5C22.9361 10.5 20.4244 12.8478 20.4244 17.0403V20.7298H16.5V25.4255H20.4244V37.2485C21.2878 37.4162 22.1511 37.5 23.0145 37.5C23.8779 37.5 24.7413 37.4162 25.6047 37.2485V25.4255H29.0582Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_917_415"
        x1={24.0012}
        y1={46.5634}
        x2={24.0012}
        y2={-0.00888574}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0062E0" />
        <stop offset={1} stopColor="#19AFFF" />
      </linearGradient>
      <clipPath id="clip0_917_415">
        <rect width={48} height={48} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFacebook;
